import { Address } from '@checkout-v2/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { SAVED_ADDRESS_LIST } from '../checkout-state';

export const LOAD_SAVED_DELIVERY_ADDRESS_LIST = '[Checkout] Load saved delivery address list';
export const LOAD_SAVED_DELIVERY_ADDRESS_LIST_SUCCESS = '[Checkout] Load saved delivery address list success';
export const LOAD_SAVED_DELIVERY_ADDRESS_LIST_FAILURE = '[Checkout] Load saved delivery address list fail';
export const LOAD_SAVED_DELIVERY_ADDRESS_LIST_RESET = '[Checkout] Load saved delivery address list reset';

export const SAVE_DELIVERY_ADDRESS = '[Checkout] Save delivery address';
export const EDIT_SAVED_DELIVERY_ADDRESS = '[Checkout] Edit saved delivery address';
export const DELETE_SAVED_DELIVERY_ADDRESS = '[Checkout] Delete saved delivery address';

export const SELECT_ACTIVE_DELIVERY_ADDRESS = '[Checkout] Select active delivery address';

export class LoadSavedDeliveryAddressList extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_SAVED_DELIVERY_ADDRESS_LIST;

  constructor() {
    super(SAVED_ADDRESS_LIST);
  }
}

export class LoadSavedDeliveryAddressListFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_SAVED_DELIVERY_ADDRESS_LIST_FAILURE;

  constructor(public payload: any) {
    super(SAVED_ADDRESS_LIST, payload);
  }
}

export class LoadSavedDeliveryAddressListSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_SAVED_DELIVERY_ADDRESS_LIST_SUCCESS;

  constructor(public payload: Address[]) {
    super(SAVED_ADDRESS_LIST);
  }
}

export class LoadSavedDeliveryAddressListReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_SAVED_DELIVERY_ADDRESS_LIST_RESET;

  constructor() {
    super(SAVED_ADDRESS_LIST);
  }
}

export class SaveDeliveryAddress implements Action {
  readonly type = SAVE_DELIVERY_ADDRESS;

  constructor(public payload: Address) {}
}

export class EditSavedDeliveryAddress implements Action {
  readonly type = EDIT_SAVED_DELIVERY_ADDRESS;

  constructor(public payload: Address) {}
}

export class DeleteSavedDeliveryAddress implements Action {
  readonly type = DELETE_SAVED_DELIVERY_ADDRESS;

  constructor(public payload: string) {}
}

export class SelectActiveDeliveryAddress implements Action {
  readonly type = SELECT_ACTIVE_DELIVERY_ADDRESS;

  constructor(public payload: string | undefined) {}
}

export type SavedDeliveryAddressAction =
  | SaveDeliveryAddress
  | EditSavedDeliveryAddress
  | SelectActiveDeliveryAddress
  | LoadSavedDeliveryAddressList
  | LoadSavedDeliveryAddressListSuccess
  | LoadSavedDeliveryAddressListFail
  | LoadSavedDeliveryAddressListReset
  | DeleteSavedDeliveryAddress;
